import React from "react";
import tracsa from "../../assets/tracsa.jpg";
import sitsa from "../../assets/sitsa.jpg";
import agtrac from "../../assets/agtrac.jpg";
import camionesmack from "../../assets/camionesmack.jpg";



const Navbar = () => {

  let company = process.env.REACT_APP_COMPANY;
  let img = '';
  switch(company){
    case 'tracsa':
      img = tracsa;
      break;
    case 'sitsa':
      img = sitsa;
      break;
    case 'agtrac':
      img = agtrac;
      break;
    case 'camionesmack':
      img = camionesmack;
      break;
    default:
      img = tracsa;
  }

  return (
    <nav
      className="navbar"
      role="navigation"
      aria-label="main navigation"
      style={{ backgroundColor: "#f9f9f9" }}
    >
      <div className="navbar-menu container">
        <div className="navbar-end">
          <div className="navbar-item">
            <img src={img} style={{ marginRight: "20px" }} alt="Tracsa" />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
